module.exports = __webpack_public_path__ + "img/keder_koenigsblau_farbnr543.4370f6ef.jpg";